// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"647":"0ff7c46caaed4d05","792":"b3904d4618922f10","907":"2a40e62e4f5dd834"}[chunkId] + ".js";
};